import "./HistoryText.css";

export default function HistoryText() {
  return (
    <div className="history">
      <h2 className="h2-history">Kerhomme historiaa:</h2>
      <p className="p-history">
        Joskus alkukesästä vuonna 2000 sekalainen joukko kokoontui Kaarelan
        VPK:n kerhohuoneelle aiheenaan moottoripyöräkerhon perustaminen.
        Palokunnassa oli havaittu muutamalla jäsenellä moottoripyörä ja
        puskaradion laulettua jonkin aikaa kaverilta kaverille ilmaantui
        perustamiskokoukseen kymmenkunta asiasta kiinnostunutta. Mitä
        kokouksessa tarkalleen päätettiin ei ole enää tarkassa tiedossa,
        oletettavasti mitään isompia paperitöitä ei edes tehty. Tärkein asia
        saatiin kuitenkin päätettyä eli perustettiin kerho, jonka tehtävänä
        olisi koota paikallisia motoristeja yhteen. Homma pidettiin alussa hyvin
        vapaamuotoisena ilman virallista rekisteröintiä.{" "}
      </p>
      <p className="p-history">
        Nimen valinnassa painotettiin jotain Vantaan Kaivokselaan liittyvää tai
        viittaavaa. Lopulta loppusuoralle päätyivät Tattila MC sekä Minebikers.
        Ensimmäinen nimi viittasi ”tattiin” eli paikalliseen vesitorniin,
        jälkimmäinen puolestaan kaivokseen eli vanhoihin avolouhoksiin joista
        oli joskus kauan sitten kaivettu rautamalmia. Minebikers tuli valituksi,
        koska nimi toimii hyvin ilman muita liitteitä, Tattila ei olisi saanut
        MC-tunnusta ilman muiden kerhojen hyväksyntää ja siihen ei katsottu
        tarpeelliseksi lähteä. Hyvin pian saatiin hahmoteltua myös nykyisinkin
        käytössä oleva logo, kypärällä ja hakulla varustautunut
        moottoripyöräilijä. Tunnusta on käytetty sekä vaatteissa että lipussa,
        jota on näytetty kokoontumisajojen yhteydessä.{" "}
      </p>
      <p className="p-history">
        Uuden kerhon ensimmäinen isompi tapahtuma oli saman kesän Jögevatreff,
        jonne saatiinkin lähes sataprosenttinen osanotto. Tapahtumasta tuli sen
        myötä vuosittainen päätapahtuma, jonne parhaimmillaan on saatu paikalle
        yli kaksikymmentä jäsentä. Alkuvaiheessa toiminta laajeni nopeasti
        jäsenistön määrän osalta ja jäseniä saatiin muualtakin, perustajäsen
        Tapsan kontaktien kautta toiminta levisi jopa Varkauteen asti, jossa
        olikin vuosia monta jögevankävijää. Kotimaan kokoontumisissakin
        kerholaisia on joskus nähty ja tietysti yksittäiset jäsenet ovat
        kantaneet värejämme ympäri eurooppaa mm. FIM ralleissa.{" "}
      </p>
      <p className="p-history">
        Kerhon aseman virallistaminen sai alkunsa kahvipöytäkeskusteluissa
        vuoden 2022 keväällä. Asia jäi hautumaan, kunnes saman kesän
        Jögevatreffissä päätettiin vihdoin alkaa tekemään asialle jotain.
        Lauantai-iltana, toisen tai ehkä jopa kolmannen nautitun Saku-oluen
        antaman rohkeuden jälkeen päätettiin yksimieleisesti lähteä hoitamaan
        homma selväksi seuraavaan Biker Meetingiin jo samana syksynä. Pitkä
        matka kokoustamaan Savon sydämeen ja syksyinen koleus saivat jarrutettua
        viime hetkellä osallistumisinnon pois ja maalitolppia siirrettiin vielä
        kerran seuraavaan kevääseen. Tuhatpäisen motoristiyleisön edessä saimme
        sönkötettyä asiamme hyväksyttävästi ja kiitos edellisellä ajokaudella
        suoritettujen vierailujen johdosta alueen muihin kerhoihin tulivat myös
        tunnukset kerralla hyväksytyiksi. Erityisenä ylpeydenaiheena havaitsimme
        olevamme kaikkiaan kuudesta hyväksyntää hakeneista kerhoista ainoa joka
        uskalsi hakea moniväritunnusta muiden tyytyessä mustavalkoisiin.{" "}
      </p>
      <p className="p-history">
        Presidenttejä kerholla on ollut vain kaksi tähän päivään mennessä,
        ensimmäinen kokous valitsi Hannu P:n tähän kunniakkaaseen tehtävään.
        Hannun into tehtävään hiipui vähitellen ja vuonna 2015 nykyinen
        pressamme Jannu otti vetovastuun joka on kantanut nykyhetkeen asti.
        Viime vuosina kerho on saanut uusia nuorempia jäseniä mikä on
        äärimmäisen hieno asia. Kahdenkymmenen vuoden aikana toiminta olisikin
        muuten jo lopahtanut ukkokerhon puuhasteluksi, nyt voimme taas
        kaasutella kohti kirkkaampaa tulevaisuutta.
      </p>
    </div>
  );
}
